export function fixMobileNumber(text: string) {
    try {
        let updatedText = fixNumber(text);
        if (!updatedText.startsWith("0")) {
            updatedText = "0" + updatedText;
        }
        return updatedText;
    } catch (e) {
        alert(e);
    }
}

export function toEnglishDigits(str) {
    return str
        .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
        .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
}

export function fixNumber(text: string): string {
    try {
        const persianNumbers = [
            "۰",
            "۱",
            "۲",
            "۳",
            "۴",
            "۵",
            "۶",
            "۷",
            "۸",
            "۹",
        ];
        const englishNumbers = [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
        ];

        let updatedText = text;

        for (let i = 0; i < text.length; i++) {
            for (let j = 0; j < persianNumbers.length; j++) {
                const persianChar = persianNumbers[j];
                const englishChar = englishNumbers[j];
                updatedText = updatedText.replace(persianChar, englishChar);
            }
        }
        return updatedText;
    } catch (e) {
        return "";
    }
}
